<template>
  <div>
    <v-dialog v-model="modal" :key="analyser.id" max-width="400">
      <Manage @close="list(), (modal = false)" :analyserProp="analyser" />
    </v-dialog>

    <v-dialog v-model="removeDialog" :key="analyser.id + 1" max-width="350">
      <v-card class="pa-4">
        <h3>Remover analisador</h3>

        <p>
          Tem certeza de que deseja remover esse analisador?
          <br />
          Todos os templates relacionados a este analisador também serão
          removidos
        </p>

        <div class="d-flex justify-end">
          <v-btn depressed color="primary" @click="removeDialog = false">
            Cancelar
          </v-btn>
          <v-btn depressed color="secondary" @click="remove">Remover</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <div class="d-flex justify-end">
      <v-btn
        color="secondary"
        depressed
        @click=";(analyser = {}), (modal = true)"
      >
        Adicionar
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="items"
      :header-props="{
        sortByText: 'Ordenar por',
      }"
      :items-per-page="items.length"
      class="main-table"
      hide-default-footer
      no-data-text="Sem registros"
    >
      <template #[`item.actions`]="{ item }">
        <v-btn icon text @click=";(analyser = item), (modal = true)">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>

        <v-btn icon text @click=";(analyser = item), (removeDialog = true)">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import Manage from './manage.vue'

export default {
  name: 'analysersTab',

  components: {
    Manage,
  },

  created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = institution.id
    this.list()
  },

  data() {
    return {
      removeDialog: false,
      apiService: new ApiService(),
      analyser: {},
      modal: false,
      addKey: false,
      page: 1,
      totalPages: 0,
      headers: [
        {
          text: '',
          align: 'center',
        },
        {
          text: 'Analisador',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      filter: {
        page: 1,
        pageSize: 10,
      },
      items: [],
    }
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },
  },

  methods: {
    remove() {
      this.loading = true
      this.apiService
        .delete(`electricalSafetyAnalyser/${this.analyser.id}`, this.filter)
        .then(() => {
          this.analyser = {}
          this.removeDialog = false
          this.list()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    list() {
      this.apiService
        .get('electricalSafetyAnalyser/paginate', this.filter)
        .then((response) => {
          this.items = response.content.data
          this.totalPages = response.content.pager.totalPages
        })
    },
  },
}
</script>

<style scoped></style>
